/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type access_AccessModuleResponse = {
    group: access_AccessModuleResponse.group;
    key: string;
};
export namespace access_AccessModuleResponse {
    export enum group {
        PEOPLE = 'people',
        DAILY_OPS = 'daily-ops',
        PROGRAMS = 'programs',
        FINANCE = 'finance',
        MOBILE = 'mobile',
    }
}

